<template>
	<apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
export default {
	props: {
		title: {
			default: "Titulo"
		},
		data: {
			type: Object
		}
	},
	mounted() {
		console.log(this.data.series)
	},
	data() {
		return {
			series: this.data
				? this.data.series
				: [
						{
							name: "High - 2013",
							data: [28, 29, 33, 36, 32, 32, 33]
						}
				  ],

			chartOptions: {
				chart: {
					height: 200,
					type: "area",
					// dropShadow: {
					// 	enabled: true,
					// 	color: "#000",
					// 	top: 18,
					// 	left: 7,
					// 	blur: 10,
					// 	opacity: 0.2
					// },
					toolbar: {
						show: false
					}
				},
				colors: ["#0168fa", "#f44336"],
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: "smooth"
				},
				title: {
					text: this.title,
					align: "left"
				},
				grid: {
					borderColor: "#e7e7e7",
					row: {
						colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
						opacity: 0.5
					}
				},
				markers: {
					size: 1
				},
				xaxis: this.data
					? this.data.xaxis
					: {
							categories: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul"],
							title: {
								text: "Mes"
							}
					  },
				yaxis: this.data
					? this.data.yaxis
					: {
							title: {
								text: "Ventas"
							},
							min: 5,
							max: 40
					  },
				legend: {
					position: "top",
					horizontalAlign: "right",
					floating: true,
					offsetY: -25,
					offsetX: -5
				}
			}
		}
	}
}
</script>
